(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
function initLuxCompare(scope){
  (scope || document).querySelectorAll('.lux-compare').forEach(function(root){
    if (root.__luxInited) return;
    root.__luxInited = true;

    const tabs = root.querySelectorAll('.tab');
    const rows = root.querySelectorAll('tbody tr[data-cat]');

    function show(cat){
      rows.forEach(tr => tr.style.display = (tr.dataset.cat === cat ? '' : 'none'));
      tabs.forEach(btn => btn.setAttribute('aria-selected', btn.dataset.cat === cat ? 'true' : 'false'));
    }

    const initial = root.querySelector('.tab[aria-selected="true"]')?.dataset.cat || 'sweets';
    show(initial);
    tabs.forEach(btn => btn.addEventListener('click', () => show(btn.dataset.cat)));
  });
}

document.addEventListener('DOMContentLoaded', function(){ initLuxCompare(document); });
document.addEventListener('shopify:section:load', function(e){ initLuxCompare(e.target); });

  } catch(e) { console.error(e); }
})();
})();
